(() => {
  const init = root => {
    root.querySelectorAll('[data-mt-specs]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const input = section.querySelector('[data-mt-spec-search]');
      const rows = [...section.querySelectorAll('[data-mt-spec-row]')];
      if (!input) return;
      input.closest('label').hidden = false;
      const normalize = value => value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase('es');
      input.addEventListener('input', () => {
        const query = normalize(input.value.trim());
        let visible = 0;
        rows.forEach(row => {
          row.hidden = !normalize(row.textContent).includes(query);
          if (!row.hidden) visible++;
        });
        section.querySelector('[data-mt-spec-empty]').hidden = visible > 0;
      });
    });
  };
  document.addEventListener('DOMContentLoaded', () => init(document));
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

(() => {
  const stickyOffset = () => {
    let bottom = 0;
    document.querySelectorAll('.shopify-section__header, .shopify-section--header, .shopify-section--announcement-bar').forEach(element => {
      const style = getComputedStyle(element);
      if (style.position !== 'sticky' && style.position !== 'fixed') return;
      const top = parseFloat(style.top) || 0;
      bottom = Math.max(bottom, Math.max(0, top) + element.getBoundingClientRect().height);
    });
    return bottom;
  };
  document.addEventListener('click', event => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download') || link.target === '_blank') return;
    let url;
    try { url = new URL(link.href, location.href); } catch { return; }
    if (url.origin !== location.origin || url.pathname !== location.pathname || url.search !== location.search) return;
    let id;
    try { id = decodeURIComponent(url.hash.slice(1)); } catch { return; }
    if (!['mt-process', 'mt-finder', 'mt-product-purchase', 'mt-product-description', 'mt-product-specifications'].includes(id) && !id.startsWith('mt-specifications-')) return;
    const section = document.getElementById(id);
    if (!section) return;
    const target = id === 'mt-process' ? section.querySelector('.mt-section-head') || section : section;
    const gap = matchMedia('(max-width: 740px)').matches ? 24 : 32;
    const top = Math.max(0, target.getBoundingClientRect().top + scrollY - stickyOffset() - gap);
    event.preventDefault();
    event.stopPropagation();
    history.replaceState(history.state, '', url.hash);
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
    window.scrollTo({top, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  }, true);

  const initialize = root => {
    root.querySelectorAll('[data-mt-vehicle-panel]').forEach(panel => {
      if (panel.dataset.mtVehicleReady) return;
      panel.dataset.mtVehicleReady = 'true';
      const results = panel.querySelector('[data-mt-vehicle-results]');
      const button = panel.querySelector('[data-mt-vehicle-products]');
      if (!results || !button) return;
      const index = () => {
        try {
          return window.easysearch?._garageGetSelectedIndex?.() || document.querySelector('.easysearch-garage-widget .easysearch-garage-item[data-selected="1"]')?.esGarageIndex || '';
        } catch { return ''; }
      };
      const nativeButton = () => panel.querySelector('.easysearch-btn-search');
      const nativeReady = () => {
        const native = nativeButton();
        return native && !native.hasAttribute('disabled') && native.getAttribute('aria-disabled') !== 'true' && /^(https?:\/\/|\/)/.test(native.getAttribute('href') || '');
      };
      const appReady = () => {
        const app = window.easysearch;
        try { return index() && typeof app?.prepareSearchUrl === 'function' && typeof app?.searchFormSubmit === 'function' && app.getUrlByIndex?.(index()); } catch { return false; }
      };
      const update = () => {
        const overlay = panel.querySelector('.easysearch-garage-overlay');
        const visible = overlay && !overlay.classList.contains('easysearch-hidden') && overlay.getClientRects().length > 0;
        results.hidden = !visible;
        button.disabled = !visible || !(appReady() || nativeReady());
      };
      button.addEventListener('click', () => {
        const holder = panel.querySelector('.easysearch-holder');
        const app = window.easysearch;
        if (holder && appReady()) {
          const url = app.prepareSearchUrl(holder, index());
          if (url) app.searchFormSubmit(holder);
        } else if (nativeReady()) nativeButton().click();
        else update();
      });
      let pending = false;
      const schedule = () => {
        if (pending) return;
        pending = true;
        requestAnimationFrame(() => { pending = false; update(); });
      };
      let observer;
      const attach = () => {
        const widget = panel.querySelector('.easysearch-main-widget');
        if (!widget) return false;
        observer?.disconnect();
        observer = new MutationObserver(schedule);
        observer.observe(widget, {subtree:true, childList:true, attributes:true, attributeFilter:['class','style','href','disabled','aria-disabled']});
        update();
        return true;
      };
      if (!attach()) {
        observer = new MutationObserver(() => attach());
        observer.observe(panel, {subtree:true, childList:true});
      }
      document.addEventListener('easysearch_ready', schedule);
      document.addEventListener('easysearch_garage_rendered', schedule);
      document.addEventListener('change', event => { if (panel.contains(event.target)) schedule(); });
      window.addEventListener('pageshow', schedule);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize(document));
  else initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
